<template>
  <v-container>
    <v-card>
      <v-card-title>Pressure Control Calculator</v-card-title>
      <v-card-text>
        <v-row
          v-for="row in modelGui"
          :key="'li-' + row.unitType"
          justify="center"
          align="center"
        >
          <v-col cols="2">{{ row.unitType }}</v-col>
          <v-col>
            <v-select
              v-model="row.sourceUnit"
              label="Source Unit"
              :items="row.items"
              variant="underlined"
              @update:model-value="
                row.targetValue = convert_gui_from_to(
                  row.sourceValue,
                  row.sourceUnit,
                  row.targetUnit,
                )
              "
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model.number="row.sourceValue"
              variant="underlined"
              @update:model-value="
                row.targetValue = convert_gui_from_to(
                  row.sourceValue,
                  row.sourceUnit,
                  row.targetUnit,
                )
              "
            />
          </v-col>
          <v-col cols="1">
            <v-icon>arrow_right_alt</v-icon>
          </v-col>
          <v-col>
            <v-select
              v-model="row.targetUnit"
              label="Target Unit"
              :items="row.items"
              variant="underlined"
              @update:model-value="
                row.targetValue = convert_gui_from_to(
                  row.sourceValue,
                  row.sourceUnit,
                  row.targetUnit,
                )
              "
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model.number="row.targetValue"
              variant="underlined"
              readonly
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useModbusStore } from "@/stores/useModbusStore";
import { ModelGuiRow } from "@/types/ModelGuiRow";
import { useDelay } from "@/composables/useDelay";

const modbusStore = useModbusStore();
const { delay } = useDelay();

const modelGui = ref<ModelGuiRow[]>([]);

function convert_gui_from_to(value: number, fromUnit: string, toUnit: string) {
  return modbusStore.convert(value, fromUnit, toUnit);
}

onMounted(async () => {
  while (!modbusStore.storeInit) {
    await delay(5);
  }
  const unitsGuiTypes = [
    "Gauge pressure",
    "Absolute pressure",
    "Temperature",
    "Level",
    "Mass Flow Rate",
    "Volumetric Flow Rate",
  ];
  for (const unitType of unitsGuiTypes) {
    const unit_items = modbusStore.guiUnits
      .filter((item) => item.unit_type == unitType)
      .map((row) => row.name);

    const modelGuiRow: ModelGuiRow = {
      unitType,
      sourceUnit: unit_items[0],
      targetUnit: unit_items[0],
      sourceValue: 0,
      targetValue: 0,
      items: unit_items,
    };
    modelGui.value = modelGui.value.concat(modelGuiRow);
  }
});
</script>
